import { createRoundedRectangularShape } from "./createRoundedRectangularShape";
import { createSimpleRectangularShape } from "./createSimpleRectangularShape";
export const createRectangularShape = (left, bottom, width, height, cornerRadius) => {
    if (cornerRadius &&
        (cornerRadius.topLeft > 0 ||
            cornerRadius.bottomRight > 0 ||
            cornerRadius.bottomLeft > 0 ||
            cornerRadius.topRight > 0)) {
        return createRoundedRectangularShape(left, bottom, width, height, cornerRadius);
    }
    return createSimpleRectangularShape(left, bottom, width, height);
};
//# sourceMappingURL=createRectangularShape.js.map